import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { constants } from '../shared/constants';
import { LocalStorageService } from '../services/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class ListingCheckoutService {

  constructor(
    private http: HttpClient,
    public localStorageService: LocalStorageService,
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
    }),
  };

  GetListingCheckoutToken(): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_token;
    return this.http
      .post<any>(url, this.httpOptions)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetPackages(fipsCode: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_packages + '?fipsCode=' + fipsCode;
    return this.http
      .get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetPackageItems(id: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_packages + '/' + id + '/items';
    return this.http
      .get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetMunicipalities(fipsCode: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_municipality + '?fipsCode=' + fipsCode;
    return this.http
      .get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetMlSs(id: any, muniId: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_packages + '/' + id + '/mls';
    if (muniId) {
      url = url + '?muniId=' + muniId;
    }
    return this.http
      .get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  CreateAccount(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_create_account;
    return this.http
      .post<any>(url, input, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  } 

  SubmitData(input: any): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_submit_data;
    return this.http
      .post<any>(url, input, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  GetOrderInfo(email: string, orderId : string): Observable<any> {
    let url = environment.prospektr_sell_backend_base_url + constants.listing_checkout_get_order_info + '?email=' + email + '&orderIds=' + orderId;
    return this.http
      .get<any>(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.localStorageService.get('lcAccessToken') ? 'Bearer ' + this.localStorageService.get('lcAccessToken') : null
        })
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }


  // Error handling
  errorHandl(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}

